import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactDOM from 'react-dom';
import styled from "styled-components";
import Header from "@/components/Header";
import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';

import Painter from './imgs/paint@2x.png';
import Btn1 from './imgs/rank-btn@2x.png';
import Btn2 from './imgs/again@2x.png';
import Btn3 from './imgs/withdrawal@2x.png';
import FullBtn from './imgs/full-btn@2x.png';

import ShareBottom from './imgs/share-bottom@2x.png';
import BtnCancel from './imgs/btn-cancel@2x.png';
import BtnDownload from './imgs/btn-download@2x.png';
import ModalBg from './imgs/modal-bg@2x.png';
import RankTip from './imgs/rank-desc@2x.png';
import DownloadIcon from './imgs/xiazai@2x.png';

import { getSimulatorResult, getMonthIncome } from './api';
import { activityShareFriend, isStorm, getIncomeSplit, handleUploadTrace } from './stock';
import bwmodel from '@/config/bwmodel';
import html2canvas from 'html2canvas';
import bridge from '@/config/JSbridge';

import ShareModal from './components/share';
import { DownWrap } from './style'
import ImageBtn from './components/btn';

import { Toast } from 'antd-mobile';
import ShareChart from './components/chart';
import ModalView from "@/components/modal-view";
import ModalTips from './components/modal-tips';

const Page3 = ({ mode, next, toRank, uniqueCode = '', activityInfo, setPlayResultInfo, playAgain }) => {

  const isLogin = !uniqueCode;
  let nickname = isLogin ? activityInfo.user.nickname : '我的账户';
  let avatar = isLogin ? activityInfo.user.avatar : '';
  if (nickname && nickname.length > 12) {
    nickname = nickname.slice(0, 12) + '...'
  }

  const [data, setData] = useState({ details: [], shDetails: [] });
  const [monthIncome, setMonthIncome] = useState([]);

  const [showRankTip, setShowRankTip] = useState(true);

  const shareRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [snapshot, setSnapshot] = useState('');

  const modalTipsRef = useRef();


  useEffect(() => {
    handleUploadTrace('end', 'visitor')
  }, [])

  const fetchSimulatorResult = () => {
    getSimulatorResult({year: 2023, uniqueCode}).then(res => {
      setData(res);
      setPlayResultInfo(res);
    })
  }

  const fetchMonthIncome = () => {
    getMonthIncome({year: 2023, uniqueCode}).then(res => {
      setMonthIncome(res.details);
    });
  }

  useEffect(() => {
    fetchSimulatorResult();
    fetchMonthIncome();

    setTimeout(() => {
      setShowRankTip(false);
    }, 5000);
  }, []);

  useEffect(() => {
    if (!isLogin) {
      Toast.loading('Loading...', 1.4)
    }
  }, [])

  const showData = monthIncome.reduce((pre, item, index) => {
    const rowIndex = Math.floor(index / 4);
    if (!pre[rowIndex]) {
      pre[rowIndex] = [];
    }
    pre[rowIndex].push(item)
    return pre;
  }, [[]])

  const wantWithdrawal = () => {
    if (!isStorm) {
      modalTipsRef.current.show({
        content: '「想要提现」功能仅限在市值风云APP使用',
      });
      return;
    }
    next();

    /** */
    handleUploadTrace('end-withdrawal', 'click')
  }

  const handleShareClick = useCallback(() => {
    playAgain();

    /** **/
    handleUploadTrace('share', 'click');
  }, []);

  const wantAgain = () => {
    if (shareRef.current) {
      shareRef.current.show()
    }

    /** **/
    handleUploadTrace('end-once-again', 'click');
  }

  const linkToDownload = () => {
    /** **/
    handleUploadTrace('download-app', 'click');

    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html";
  }

  const handleShare = () => {
    const income = (data.incomeRatio ? Number(data.incomeRatio * 100).toFixed(2) : 0) + '%';
    activityShareFriend(income)
  }

  useEffect(() => {
    if (!isLogin && data.details && data.details.length > 0) {
      renderShareDom().then(url => {
        setSnapshot(url);
      })
    }
  }, [data])

  const renderShareDom = () => {
    return new Promise((resolve, reject) => {
      const container = document.createElement('div');
      document.body.appendChild(container);
      ReactDOM.render(
        <ShareContainer>
          {isLogin && <div className="user-wrap">
            <img src={avatar} alt='' className="avatar"/>
            <div className="user-name">{nickname}</div>
          </div>}
          <IncomeWrap className="share-income-wrap">
            <div className="income-text share-income-text">穿越2023年重来后，我的全年盈亏:</div>
            <div className="income-value">
              <span>{getIncomeSplit(data.income)}</span>
              <span className="income-unit">元</span>
            </div>
            <div className="income-ratio share-income-text">收益率: {data.incomeRatio ? Number(data.incomeRatio * 100).toFixed(2) : 0}%</div>
          </IncomeWrap>
          <div className="chart-wrap">
            <ShareChart animation={false} data={data} nickname={nickname} mode={mode} />

            <MonthIncome className="month-income-wrap">
              <div className="income-title">2023年盈亏</div>
              <div className="month-income">
                {showData.map((row, index) => {
                  return <div className="month-row" style={row.length < 4 ? {justifyContent: 'unset'} : {}} key={index}>
                    {row.map((item, itemIndex) => {
                      return (
                        <div className="month-item">
                          <div className="month-item-num">{index * 4 + itemIndex + 1}月</div>
                          <div className="month-item-stock">{item.stockName}</div>
                          <div className="month-item-ratio">{(item.incomeRatio * 100).toFixed(2)}%</div>
                        </div>
                      )
                    })}
                  </div>
                })}
                
              </div>
            </MonthIncome>
            <div className="share-text">扫描识别二维码，体验《重生之股神模拟器》</div>
            <img src={ShareBottom} alt='' className="share-bottom"/>
          </div>
        </ShareContainer>,
        container
      );
      setTimeout(() => {
        html2canvas(container, {
          useCORS: true,
          allowTaint: true
        })
          .then(function (canvas) {
            const url = canvas.toDataURL();
            document.body.removeChild(container);
            resolve(url);
          })
          .catch((err) => {
            reject(err);
          });
      }, 1000);
    });
  };

  const handleFullPlay = () => {
    /** **/
    handleUploadTrace('download-app', 'click');

    /** */
    handleUploadTrace('end-download-app', 'click')


    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html";
  }

  const handleDownloadPorfit = () => {
    if (isStorm) {
      Toast.loading('正在保存...', 1.4)
      renderShareDom()
      .then((url) => {
        bridge.callHandler('nativeEvent', {
          event: "saveImage",
          params: {
            imageData: url.replace('data:image/png;base64,', ''),
          }
        }, res => {
          Toast.hide()
          const result = JSON.parse(res);
          if (result.code === 0) {
            Toast.info('已保存到相册')
          } else {
            Toast.info('保存失败')
          }
        })
      })
      .catch((err) => {
        // console.log(err, 'err');
      });
    }
  }

  return (
    <Container>
      {isStorm &&
        <Header
          title="重生之股神模拟器"
          right={<img onClick={handleShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />
          
          <div className="painter-conent">
            <img alt="" src={Painter} className='painter'/>

            <div className="profit-tip-bg">
              <div onClick={handleDownloadPorfit} className="profit-tip-box">
                <img src={DownloadIcon} className="profit-bg-img" alt=""/>
                <div className="profit-text">{isStorm ? '点击下载收益图' : '长按收益图保存图片'}</div>
              </div>
            </div>
            
            <div className="btn-wrap">
              <img onClick={() => toRank()} alt=""  src={Btn1} className='option-img'/>
              {isStorm ? <img onClick={wantAgain} alt="" src={Btn2} className='option-img'/> : <img onClick={handleFullPlay} className='full-btn' alt="" src={FullBtn}/>}
              <img onClick={wantWithdrawal} alt="" src={Btn3} className='option-img'/>
              {showRankTip && <img src={RankTip} alt="" className="rank-tip" />}
            </div>

            <div className="scroll-box scroll-container">
              

              {(!isLogin) ? 
                <img src={snapshot} alt='' className="snapshot" /> : 
                <div>
                  <div className="user-wrap">
                    <img src={avatar} alt='' className="avatar"/>
                    <div className="user-name">{nickname}</div>
                  </div>
                  <IncomeWrap className="income-wrap">
                    <div className="income-text">穿越2023年重来后，我的全年盈亏:</div>
                    <div className="income-value">
                      <span>{getIncomeSplit(data.income)}</span>
                      <span className="income-unit">元</span>
                    </div>
                    <div className="income-ratio">收益率: {data.incomeRatio ? Number(data.incomeRatio * 100).toFixed(2) : 0}%</div>
                  </IncomeWrap>

                  <div className="chart-wrap">
                    <div className="chart-box scroll-container">
                      <ShareChart mode={mode} data={data} nickname={nickname}/>
                      <MonthIncome>
                        <div className="income-title">2023年盈亏</div>
                        <div className="month-income">
                          {showData.map((row, index) => {
                            return <div className="month-row" style={row.length < 4 ? {justifyContent: 'unset'} : {}} key={index}>
                              {row.map((item, itemIndex) => {
                                return (
                                  <div className="month-item">
                                    <div className="month-item-num">{index * 4 + itemIndex + 1}月</div>
                                    <div className="month-item-stock">{item.stockName}</div>
                                    <div className="month-item-ratio">{(item.incomeRatio * 100).toFixed(2)}%</div>
                                  </div>
                                )
                              })}
                            </div>
                          })}
                        </div>
                      </MonthIncome>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <ModalView
        visible={showModal}
        onClose={() => setShowModal(false)}
        content={
          <DownWrap>
            <img id="modal-bg" className="modal-bg" src={ModalBg} alt='' />
            <div className="modal-content">
              <div className="modal-title">提示</div>
              <div className="modal-tip">前往市值风云APP解锁完整游戏</div>
            </div>
            <div className="modal-btn-wrap">
              <ImageBtn onClick={() => setShowModal(false)} img={BtnCancel} className="modal-btn-box" />
              <ImageBtn onClick={linkToDownload} img={BtnDownload} className="modal-btn-box" />
            </div>
          </DownWrap>
        }
      />
      <ShareModal income={`${data.incomeRatio ? Number(data.incomeRatio * 100).toFixed(2) : 0}%`} ref={shareRef} onShareClick={handleShareClick}/>
      <ModalTips ref={modalTipsRef}/>
    </Container>
  );
}

export default React.memo(Page3);

const ShareContainer = styled.div`
  background-color: #B13B2C;
  .share-income-wrap {
    padding-top: 30px !important;
  }
  .chart-wrap {
    background-color: #fff;
    margin-top: 14px;
    border-top-left-radius: 19px;
    border-top-right-radius: 19px;
    padding-top: 12px;
    font-size: 0;
  }
  .share-bottom {
    width: 100%;
  }
  .share-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 61.5px;
    font-size: 14px;
    font-weight: 400;
    color: #000;
  }
  .share-income-text {
    font-size: 16px !important;
    line-height: 16px !important;
  }
  .share-income-text {
    font-size: 16px !important;
    line-height: 16px !important;
  }
  .chart-container {
    height: 220px !important;
    padding: 0 10px;
  }
  .month-income-wrap {
    padding: 0 17px;
  }
  .user-wrap {
    display: flex;
    align-items: center;
    padding: 20px 0 0 19px;
    .avatar {
      width: 27px;
      height: 27px;
      margin-right: 11.5px;
      border-radius: 13.5px;
    }
    .user-name {
      font-size: 15.5px;
      font-weight: 400;
      color: #F4D4BC;
    }
  }
`;

const IncomeWrap = styled.div`
  color: #F4D4BC;
  width: 100%;
  text-align: center;
  padding-top: 7px;
  position: relative;
  z-index: 4;
  .income-text {
    font-size: 12px;
    font-weight: 400;
    
    line-height: 12px;
    margin-bottom: 10px;
  }
  .income-value {
    font-size: 22px;
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 7px;
    .income-unit {
      font-size: 18.5px;
      margin-left: 6px;
    }
  }
  .income-ratio {
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
  }
`

const MonthIncome = styled.div`
margin-top: 25px;
padding: 0 13px;
.income-title {
  font-size: 13.5px;
  font-weight: bold;
  color: #B13B2C;
  line-height: 13.5px;
  margin-bottom: 12px;
}
.month-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
  .month-item {
    max-width: 25%;
    flex: 1;
    margin-right: 2px;
    background: #B13B2C;
    text-align: right;
    white-space: nowrap;
    font-size: 12px;
    color: #FFF;
    padding: 8px 4px 8px 0;
    box-sizing: border-box;
    &:last-child {
      margin-right: 0;
    }
    .month-item-num {
      white-space: nowrap;
    }
    .month-item-stock {
      margin-top: 4px;
      white-space: nowrap;
    }
    .month-item-ratio {
      margin-top: 4px;
      white-space: nowrap;
    }
  }
}
`;

const Container = styled.div`
.user-wrap {
  display: flex;
  align-items: center;
  padding: 10px 0 0 19px;
  .avatar {
    width: 27px;
    height: 27px;
    margin-right: 11.5px;
    border-radius: 13.5px;
  }
  .user-name {
    font-size: 15.5px;
    font-weight: 400;
    color: #F4D4BC;
  }
}
  .page-content {
    display: flex;
    align-items: center;
  }
  .declaim-img {
    position: absolute;
    top: 0;
    left: 0;
  }
  .painter-conent {
    position: relative;
    width: 368px;
    height: 591px;
    margin: 0 auto;
  }
  .painter {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 2;
  }
  .snapshot {
    width: 100%;
  }
  .scroll-box {
    padding-left: 42px;
    padding-right: 48px;
    overflow-y: scroll;
    position: relative;
    z-index: 2;
    height: 424px;
    top: 36px;
    font-size: 0
    .income-wrap {
      padding-top: 16px;
    }
  }
  .btn-wrap {
    position: absolute;
    padding: 0 30px;
    box-sizing: border-box;
    left: 0;
    bottom: 26px;
    width: 100%;
    z-index: 3;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .option-img {
      width: 70px;
      height: 86px;
    }
    .full-btn {
      width: 86px;
      height: 86px;
    }
    .rank-tip {
      position: absolute;
      left: 37px;
      bottom: 65px;
      width: 298px;
      height: 46px;
    }
  }
  
  .chart-wrap {
    margin-top: 14px;
    .chart-box {
      background: #FFF;
      border-radius: 12.5px;
      padding: 13.5px 0;
      box-sizing: border-box;
      .chart-container {
        height: 190px;
      }
    }
  }
  .profit-tip-bg {
    width: 100%;
    height: 20px;
    top: 432px;
    left: 0;
    z-index: 3;
    position: absolute;
    padding: 0 48px 0 42px;
    box-sizing: border-box;
    .profit-tip-box {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 3, 0.8);
      height: 30px;
    }
    .profit-bg-img {
      width: 12px;
      height: 11px;
    }
    .profit-text {
      font-size: 11px;
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 4px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/page3.js